/* PSM Find-My-Replacement widget.
   Reused by both the dev harness and the Shopify theme section.

   Usage:
     PSMReplacementFinder.mount({ el, apiBase, storefrontBase, mode, onHuman });
       el            container element or selector (omit for floating launcher)
       apiBase       backend base URL ('' = same origin)
       storefrontBase prefix for product links (default https://powersupplymall.com)
       mode          'inline' | 'floating' (default 'floating')
       onHuman       callback to open live chat (Zoho). Default: console.log.
       contactEmail  fallback support address used in error copy (default contact@powersupplymall.com)
*/
(function () {
  "use strict";
  var ICONS = {
    cam: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3Z"/><circle cx="12" cy="13" r="3.5"/></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5Z"/></svg>',
    head: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    support: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="2" y="13.5" width="4.5" height="7" rx="2"/><rect x="17.5" y="13.5" width="4.5" height="7" rx="2"/><path d="M20 20.5a3 3 0 0 1-3 3h-3"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r="1.25"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>',
    clip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>',
    file: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6"/></svg>'
  };

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }
  var _cur = "$";  // store currency symbol (e.g. "NZ$"); set from the /session response
  function money(p) { return p == null ? "" : _cur + Number(p).toFixed(2); }
  // Render assistant/agent text: escape (safety first), then a small, safe subset of the markdown
  // the assistant writes — bare URLs → links, **bold**, and "- "/"* " bullet lines — keeping line
  // breaks. Everything is escaped before any tag is inserted, so no HTML injection.
  function richText(s) {
    return esc(s)
      .replace(/(https?:\/\/[^\s<]+)/g, function (raw) {
        // Keep sentence punctuation (and the escaped quote/angle entities) out of the link: "see
        // https://x.test/p)." must link to https://x.test/p only.
        var parts = /^([\s\S]*?)((?:[.,;:!?)\]']|&quot;|&gt;|&amp;)*)$/.exec(raw), u = parts[1], tail = parts[2];
        return '<a href="' + u + '" target="_blank" rel="noopener noreferrer">' + u + "</a>" + tail;
      })
      .replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>")   // **bold**
      .replace(/^[ \t]*[-*][ \t]+/gm, "• ")                    // "- item" / "* item" → bullet
      .replace(/\n/g, "<br>");
  }

  // Downscale a photo client-side before upload (cuts bandwidth + vision cost).
  function downscale(file, maxDim, quality) {
    maxDim = maxDim || 1600; quality = quality || 0.85;
    return new Promise(function (resolve) {
      try {
        var img = new Image();
        var objUrl = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(objUrl);  // free the blob mapping — the image is already decoded
          var w = img.width, h = img.height;
          if (!w || !h || (w <= maxDim && h <= maxDim)) { resolve(file); return; }
          var scale = Math.min(maxDim / w, maxDim / h);
          var c = document.createElement("canvas");
          c.width = Math.round(w * scale); c.height = Math.round(h * scale);
          c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function (b) { resolve(b || file); }, "image/jpeg", quality);
        };
        img.onerror = function () { URL.revokeObjectURL(objUrl); resolve(file); };
        img.src = objUrl;
      } catch (e) { resolve(file); }
    });
  }

  var _instance = null;  // last mounted instance, for the global open() hook

  function mount(opts) {
    if (_instance && _instance.destroy) { try { _instance.destroy(); } catch (e) {} }  // no stacked timers/listeners on re-mount
    opts = opts || {};
    var apiBase = opts.apiBase || "";
    var storefront = opts.storefrontBase || "https://powersupplymall.com";
    // Store-appropriate fallback address for error copy ("please email us…").
    var contactEmail = opts.contactEmail || "contact@powersupplymall.com";
    // Which storefront are we on? Drives KB article scoping server-side. Explicit
    // opts.site wins; otherwise infer from the domain (works with no per-theme config).
    var site = opts.site || (function (s) {
      var h = ((location.hostname || "") + " " + s).toLowerCase();
      if (h.indexOf("wellforces.co.nz") >= 0) return "nz";
      if (h.indexOf("wellforces.com") >= 0) return "wellforces";
      return "psm";
    })(storefront);
    var mode = opts.mode || (opts.el ? "inline" : "floating");
    var onHuman = opts.onHuman || function () { console.log("[PSMReplacementFinder] open human chat"); };
    var brandName = opts.brandName || "Live Support";
    // App-Proxy identity path. The theme passes it ONLY when {{ customer }} is logged
    // in; the proxy signs the request + adds the VERIFIED logged_in_customer_id, and
    // temporal mints a short-lived token we forward on /session (→ order/return access).
    var identityUrl = opts.identityUrl || null;
    var idToken = null, idExp = 0;
    // Persist the chat session across full-page navigations (the Sign-in redirect) and
    // refreshes: remember the server session id (+ a freshness stamp) in localStorage and
    // reconnect to it, so the conversation — and a post-login customer upgrade — survive.
    var SID_KEY = "psmrf_sid_" + site, REOPEN_KEY = "psmrf_reopen_" + site, SID_TTL = 6 * 3600 * 1000;
    function loadSid() {
      try { var o = JSON.parse(localStorage.getItem(SID_KEY) || "null");
        if (o && o.id && (Date.now() - o.t) < SID_TTL) return o.id;
        localStorage.removeItem(SID_KEY); } catch (e) {}
      return null;
    }
    function saveSid(id) { try { if (id) localStorage.setItem(SID_KEY, JSON.stringify({ id: id, t: Date.now() })); } catch (e) {} }
    function clearSid() { try { localStorage.removeItem(SID_KEY); } catch (e) {} }

    var root = el("div", "psmrf");
    var panel, log, fileInput, attachInput, input, sid = null, rendered = 0, started = false, launcher = null, photoCount = 0;
    var pendingUpload = null;  // set by uploadZone(prompt, onFile) to route the NEXT shared-fileInput pick to onFile instead of upload()
    var humanMode = false, pollTimer = null, watchTimer = null, ambientTimer = null, audioCtx = null, notifyArmed = false;
    var humanAvailable = false, leaveMsgMode = false, supportTimer = null, signedIn = false, leaveMsg = null;
    var priceGate = false;  // B2B store (wellforces.co.nz): never show a price in chat; prompt sign-in instead
    var contactAsked = false, hasEmail = false;
    var afterEmail = null;  // one-shot action once a conversationally-asked email is captured: "handoff" | "lead"  // guest contact capture (soft ask shown once; server knows the email)
    var opening = false, onVis = null, onFocus = null;

    // Scheme allowlist — reject javascript:/data:/vbscript: and any attribute/tag-breakout chars.
    // Product/article URLs come from the backend/LLM/KB pipeline, so treat them as untrusted.
    function safeUrl(u) {
      u = String(u == null ? "" : u).trim();
      if (/^(javascript|data|vbscript):/i.test(u)) return "#";
      if (/[\s"'<>`]/.test(u)) return "#";
      if (/^https?:\/\//i.test(u) || /^[\/#]/.test(u)) return u;
      return "#";
    }
    function productUrl(c) {
      var u = c.url || (c.handle ? "/products/" + c.handle : null);
      if (!u) return "#";
      return safeUrl(/^https?:/.test(u) ? u : storefront + u);
    }

    function build() {
      panel = el("div", "psmrf-panel " + mode);
      panel.innerHTML =
        '<div class="psmrf-head"><span class="ava">' + ICONS.support + "</span>" +
        '<div class="t"><b>' + esc(brandName) + '</b><span>AI support</span></div>' +
        '<button class="psmrf-newchat" title="Start a new chat" aria-label="Start a new chat">' + ICONS.plus + "</button>" +
        (mode === "floating" ? '<button class="x" aria-label="close">×</button>' : "") +
        "</div>" +
        '<div class="psmrf-log"></div>' +
        '<div class="psmrf-composer">' +
        '<button class="psmrf-attach" aria-label="Attach a file" title="Attach a file" style="display:none">' + ICONS.clip + "</button>" +
        '<input type="text" placeholder="Ask a question…" aria-label="message">' +
        '<button class="psmrf-send" aria-label="Send message">' + ICONS.send + "</button></div>" +
        '<button class="psmrf-humanlink">' + ICONS.head + " Talk to a human</button>";
      log = panel.querySelector(".psmrf-log");

      fileInput = el("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      fileInput.setAttribute("capture", "environment");
      fileInput.style.display = "none";
      fileInput.addEventListener("change", function () {
        var handler = pendingUpload || upload; pendingUpload = null;
        if (fileInput.files && fileInput.files[0]) handler(fileInput.files[0]);
      });
      panel.appendChild(fileInput);

      // Separate, any-file input for HUMAN mode (relayed to the agent via Chatwoot, no
      // vision). Kept out of the AI flow so the assistant stays text-only (token-light).
      attachInput = el("input");
      attachInput.type = "file";
      attachInput.accept = "image/*,application/pdf,.doc,.docx,.txt,.csv,.xls,.xlsx,.heic";
      attachInput.style.display = "none";
      attachInput.addEventListener("change", function () {
        if (attachInput.files && attachInput.files[0]) uploadAttachment(attachInput.files[0]);
        attachInput.value = "";  // allow re-selecting the same file
      });
      panel.appendChild(attachInput);
      panel.querySelector(".psmrf-attach").addEventListener("click", function () { attachInput.click(); });

      panel.querySelector(".psmrf-newchat").addEventListener("click", function () { newChat(); });
      input = panel.querySelector(".psmrf-composer input");
      function submit() { if (input.value.trim()) { sendText(input.value.trim()); input.value = ""; } }
      panel.querySelector(".psmrf-send").addEventListener("click", submit);
      input.addEventListener("keydown", function (e) { if (e.key === "Enter") submit(); });
      panel.querySelector(".psmrf-humanlink").addEventListener("click", function () {
        if (humanAvailable) humanHandoff(); else startLeaveMessage();
      });
      if (mode === "floating") {
        panel.querySelector(".x").addEventListener("click", function () { panel.style.display = "none"; stopAmbient(); });
      }
      root.appendChild(panel);
      applyPresence();                                  // conservative default until the first poll
      pollSupport();                                    // is a human online right now?
      if (!supportTimer) supportTimer = setInterval(function () { pollSupport(); }, 30000);
      // Re-check the moment the tab is looked at again (background-tab timers are throttled, so an
      // agent going online while the customer is elsewhere would otherwise need a page refresh).
      // fresh=1 bypasses the server cache so the change shows immediately. Keep refs to tear down.
      onVis = function () { if (!document.hidden) pollSupport(true); };
      onFocus = function () { pollSupport(true); };
      document.addEventListener("visibilitychange", onVis);
      window.addEventListener("focus", onFocus);
    }

    var lastDetected = null;
    function detected() { return lastDetected; }

    function addBot(html) {
      var m = el("div", "psmrf-msg bot", '<span class="mava">' + ICONS.support + '</span><div class="b">' + html + "</div>");
      log.appendChild(m); scroll(); return m.querySelector(".b");
    }
    function addUser(html) {
      log.appendChild(el("div", "psmrf-msg user", '<div class="b">' + html + "</div>")); scroll();
    }
    // Optimistic thumbnail bubble for an uploaded file. For images we preview via an object URL and
    // revoke it once the <img> has loaded (the decoded image stays; the blob mapping is freed).
    function addUserThumb(file, isImg) {
      var url = null, inner;
      if (isImg) {
        url = URL.createObjectURL(file);
        inner = "<img><small>" + esc(file.name) + "</small>";
      } else {
        inner = '<span class="psmrf-fileicon">' + ICONS.file + "</span><small>" + esc(file.name) + "</small>";
      }
      var m = el("div", "psmrf-msg user", '<div class="b"><div class="psmrf-thumb">' + inner + "</div></div>");
      if (url) {
        var img = m.querySelector("img");
        img.onload = img.onerror = function () { URL.revokeObjectURL(url); };
        img.src = url;
      }
      log.appendChild(m); scroll();
    }
    // Initials from an agent's name ("Lenny Peng" → "LP"), mirroring Chatwoot's default avatar.
    function initials(name) {
      var p = String(name || "").trim().split(/\s+/).filter(Boolean);
      if (!p.length) return "";
      return (p[0].charAt(0) + (p.length > 1 ? p[p.length - 1].charAt(0) : "")).toUpperCase();
    }
    // Agent avatar: the Chatwoot-uploaded image if any (overlaid on the initials so a broken image
    // falls back cleanly), else the initials box (like "LP"), else the default headset icon.
    function agentAvatar(name, avatar) {
      var ini = initials(name);
      var base = ini || ICONS.head;
      var cls = "mava agent" + (ini ? " initials" : "");
      var img = (avatar && /^https?:/.test(avatar))
        ? '<img src="' + esc(avatar) + '" alt="" onerror="this.remove()">' : "";
      return '<span class="' + cls + '">' + base + img + "</span>";
    }
    function addAgent(html, name, avatar) {
      clearWaitProgress();  // the rep replied — the "finding you a specialist" indicator is done
      var wc = log.querySelector(".psmrf-waitcard"); if (wc) wc.remove();  // "while you wait" is over too
      var label = name ? '<div class="psmrf-agentname">' + esc(name) + "</div>" : "";
      log.appendChild(el("div", "psmrf-msg bot agent", agentAvatar(name, avatar) + '<div class="b">' + label + html + "</div>")); scroll();
      if (name) { var st = panel.querySelector(".psmrf-head .t span"); if (st) st.textContent = name + " · here to help"; }
    }
    function addSystem(html) {
      log.appendChild(el("div", "psmrf-sys", html)); scroll();
    }
    function renderMessage(m) {
      if (m.role === "assistant") {
        var body = addBot(richText(m.text));
        // "full" → show the card(s) below the reply. "inline" → make the model name(s) in the reply
        // clickable so the card expands on demand (doesn't interrupt the conversation flow).
        if (m.cards) { if (m.cards.mode === "inline") makeInlineProducts(body, m.cards); else renderCards(m.cards); }
      }
      else if (m.role === "agent") addAgent(richText(m.text), m.name, m.avatar);
      else if (m.role === "system") addSystem(esc(m.text));
      // Internal transcript markers the backend records for context ("[price-match screenshot
      // uploaded]", "[price-match request submitted: …]", "[sent a file: …]") — kept for logging /
      // human handoff, but never shown to the customer as a chat bubble (incl. on resume).
      else if (/^\[[^\]]*\]$/.test((m.text || "").trim())) { /* skip */ }
      else addUser(esc(m.text));
    }
    // Turn each product SKU mentioned in an assistant reply into a clickable chip that expands its
    // full card on click (inline mode). The card data rides along on the message.
    function makeInlineProducts(body, cards) {
      if (!body) return;
      // Prefer the full candidate pool so EVERY product the agent named is clickable, not just the
      // top three; fall back to best + alternatives.
      var prods = (cards.pool && cards.pool.length) ? cards.pool.slice()
        : (cards.best ? [cards.best] : []).concat(cards.alternatives || []);
      if (!prods.length) return;
      var bySku = {}, skus = [];
      prods.forEach(function (p) { if (p && p.sku && !bySku[p.sku]) { bySku[p.sku] = p; skus.push(p.sku); } });
      if (!skus.length) return;
      var alt = skus.map(function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }).join("|");
      var reSrc;
      try { new RegExp("(?<![\\w-])x"); reSrc = "(?<![\\w-])(" + alt + ")(?![\\w-])"; }
      catch (err) { reSrc = "(" + alt + ")(?![\\w-])"; }
      // Walk TEXT nodes only (never touch tags/attributes) and wrap SKU matches via createElement —
      // avoids HTML corruption from an innerHTML string-replace and any '$' replacement-pattern issue.
      var nodes = [], w = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
      while (w.nextNode()) nodes.push(w.currentNode);
      nodes.forEach(function (node) {
        if (!node.nodeValue || (node.parentNode && node.parentNode.closest && node.parentNode.closest("a"))) return;
        var txt = node.nodeValue, re = new RegExp(reSrc, "g"), m, frag = null, last = 0;
        while ((m = re.exec(txt))) {
          frag = frag || document.createDocumentFragment();
          if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
          var chip = document.createElement("a");
          // A real link to the product page (opens in a new tab). Falls back to "#" (card-expand only)
          // when the product has no URL.
          var chipUrl = bySku[m[1]] ? productUrl(bySku[m[1]]) : "#";
          chip.href = chipUrl; chip.className = "psmrf-inprod"; chip.setAttribute("data-sku", m[1]);
          if (chipUrl !== "#") { chip.target = "_blank"; chip.rel = "noopener noreferrer"; }
          chip.innerHTML = esc(m[1]) + ICONS.box;
          frag.appendChild(chip);
          last = m.index + m[0].length;
        }
        if (frag) {
          if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
          node.parentNode.replaceChild(frag, node);
        }
      });
      var msg = body.parentNode && body.parentNode.closest ? body.parentNode.closest(".psmrf-msg") : null;
      msg = msg || (body.parentNode && body.parentNode.parentNode) || body.parentNode;
      body.querySelectorAll(".psmrf-inprod").forEach(function (a) {
        a.addEventListener("click", function (e) {
          // Navigation wins: a chip with a real product URL just opens it in a new tab (default action).
          // Only a URL-less chip ("#") falls back to expanding the product card in place.
          if (a.getAttribute("href") !== "#") return;
          e.preventDefault();
          if (a._card && a._card.parentNode) { a._card.parentNode.removeChild(a._card); a._card = null; a.classList.remove("on"); return; }
          var c = card(bySku[a.getAttribute("data-sku")], true);
          c.classList.add("psmrf-inprod-card");
          if (msg && msg.parentNode) msg.parentNode.insertBefore(c, msg.nextSibling); else log.appendChild(c);
          a._card = c; a.classList.add("on"); scroll();
        });
      });
    }
    function syncMessages(d) {
      var msgs = d.messages || [];
      for (var i = rendered; i < msgs.length; i++) { renderMessage(msgs[i]); notifyNew(msgs[i]); }
      // Only advance — a stale/slow poll must never lower the counter (would re-render).
      if (msgs.length > rendered) rendered = msgs.length;
    }

    // ── new-message notification ──────────────────────────────────────────────
    // A soft ding, plus a desktop notification when the customer isn't looking at the chat —
    // so someone waiting on a human reply doesn't have to keep the tab in focus.
    function armNotifications() {
      // Call on a user gesture (sending a message / asking for a human): unlocks audio autoplay
      // and asks for notification permission while we're allowed to.
      notifyArmed = true;
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (AC && !audioCtx) audioCtx = new AC();
        if (audioCtx && audioCtx.state === "suspended") audioCtx.resume();
      } catch (e) {}
      try {
        if ("Notification" in window && Notification.permission === "default") Notification.requestPermission();
      } catch (e) {}
    }
    function ding() {
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (AC && !audioCtx) audioCtx = new AC();
        if (!audioCtx) return;
        if (audioCtx.state === "suspended") audioCtx.resume();
        var t0 = audioCtx.currentTime;
        [[880, 0], [1175, 0.13]].forEach(function (n) {  // two soft notes
          var o = audioCtx.createOscillator(), g = audioCtx.createGain(), t = t0 + n[1];
          o.type = "sine"; o.frequency.value = n[0];
          g.gain.setValueAtTime(0.0001, t);
          g.gain.exponentialRampToValueAtTime(0.16, t + 0.02);
          g.gain.exponentialRampToValueAtTime(0.0001, t + 0.25);
          o.connect(g); g.connect(audioCtx.destination);
          o.start(t); o.stop(t + 0.26);
        });
      } catch (e) {}
    }
    function chatAway() {
      try { return document.hidden || !panel || panel.style.display === "none"; } catch (e) { return false; }
    }
    function desktopNotify(title, body) {
      try {
        if (!("Notification" in window) || Notification.permission !== "granted" || !chatAway()) return;
        var n = new Notification(title || brandName, { body: (body || "").slice(0, 140), tag: "psmrf-" + site });
        n.onclick = function () { try { window.focus(); api.open(); } catch (e) {} n.close(); };
      } catch (e) {}
    }
    // Ding for any message the customer didn't send: always for a human agent or a system notice
    // (e.g. "agent has left"); for an AI reply only when they're looking elsewhere, so an active
    // back-and-forth with the assistant doesn't get noisy.
    function notifyNew(m) {
      if (!notifyArmed || !m || m.role === "user") return;
      if (m.role === "agent" || m.role === "system" || (m.role === "assistant" && chatAway())) {
        ding();
        desktopNotify(m.role === "agent" ? (m.name || brandName) : brandName, m.text);
      }
    }
    function scroll() { log.scrollTop = log.scrollHeight; }
    var typingNode = null;
    function showTyping() { hideTyping(); typingNode = el("div", "psmrf-msg bot", '<span class="mava">' + ICONS.support + '</span><div class="b" style="padding:0"><div class="psmrf-typing"><i></i><i></i><i></i></div></div>'); log.appendChild(typingNode); scroll(); }
    function hideTyping() { if (typingNode) { typingNode.remove(); typingNode = null; } }

    // onFile (optional): route the picked/dropped image to this function instead of the default
    // upload() — used by the price-match evidence zone, which posts to a different endpoint.
    function uploadZone(prompt, onFile) {
      var handle = onFile || upload;
      var z = el("div", "psmrf-uploadzone",
        '<div class="uic">' + ICONS.cam + "</div><b>" + esc(prompt || "Take / upload a photo") + "</b>" +
        "<small>Tap to take a photo · or drag &amp; drop an image here</small>");
      z.addEventListener("click", function () { pendingUpload = onFile || null; fileInput.click(); });
      function stop(e) { e.preventDefault(); e.stopPropagation(); }
      ["dragenter", "dragover"].forEach(function (ev) {
        z.addEventListener(ev, function (e) { stop(e); z.classList.add("psmrf-drag"); });
      });
      ["dragleave", "dragend", "drop"].forEach(function (ev) {
        z.addEventListener(ev, function (e) { stop(e); z.classList.remove("psmrf-drag"); });
      });
      z.addEventListener("drop", function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f && /^image\//.test(f.type)) handle(f);
        else if (f) err("Please drop an image file (JPG/PNG).");
      });
      return z;
    }

    // ── guest contact capture ────────────────────────────────────────────────
    // Soft ask (once, after the first answered message): a dismissible email card — "in case we
    // get disconnected". Never blocks anything; the human-handoff gate below is the only place
    // an email is REQUIRED (and that rule is enforced server-side).
    function contactCopy(reason) {
      return reason === "disposable"
        ? "Please use a real (non-temporary) email so our team can reach you."
        : "Hmm, that email doesn't look right — mind double-checking?";
    }
    // Ask for an email as a NORMAL chat line (no boxed card): the backend arms conversational
    // capture (session.email_prompted), and an email the customer types in ANY later message is
    // picked up, validated, and acknowledged in-flow. Ignoring the ask just continues the
    // conversation — no Skip button needed. kinds: soft | wait | gate | lead (fixed server copy).
    async function promptEmail(kind) {
      if (!sid || signedIn || hasEmail) return;
      contactAsked = true;  // any ask counts — never follow up with a second "by the way" soft ask
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/email-prompt", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ kind: kind })
        });
        if (r.ok) { syncMessages(await r.json()); scroll(); }
      } catch (e) { /* the ask is best-effort — never surface an error for it */ }
    }
    function maybeSoftAsk() {
      if (signedIn || hasEmail || contactAsked || humanMode || leaveMsgMode || !sid) return;
      if (log.querySelector(".psmrf-pmform, .psmrf-leadcard, .psmrf-leaveoffer")) return;  // another email UI is up
      contactAsked = true;
      promptEmail("soft");
    }

    // Offline sales-lead capture: rep unavailable, AI answered — offer a follow-up quote.
    // One-tap when the email is known; otherwise the tap asks for the email IN-CHAT and the
    // captured email completes the request (afterEmail hook).
    function renderLeadCard() {
      if (log.querySelector(".psmrf-leadcard")) return;
      contactAsked = true;  // the quote offer doubles as the email ask — never also soft-ask
      var known = signedIn || hasEmail;
      var card = el("div", "psmrf-contact psmrf-leadcard",
        "<b>💬 Want a tailored quote?</b> <span>— our product specialists are offline right now — " +
        "we'll follow up with a proper recommendation.</span>" +
        '<div class="psmrf-contactrow"><button class="psmrf-btn red psmrf-leadgo" type="button">' +
        (known ? "Yes, follow me up" : "Request follow-up") + "</button></div>" +
        '<div class="psmrf-pmerr" style="display:none"></div>');
      var errBox = card.querySelector(".psmrf-pmerr");
      var btn = card.querySelector(".psmrf-leadgo");
      btn.addEventListener("click", function () {
        if (!(signedIn || hasEmail)) {  // no email yet → ask in-chat; capture completes the request
          afterEmail = "lead"; card.remove(); promptEmail("lead"); return;
        }
        submitSalesLead(card, btn, errBox);
      });
      log.appendChild(card); scroll();
    }
    async function submitSalesLead(card, btn, errBox) {
      if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/sales-lead", {
          method: "POST", headers: { "Content-Type": "application/json" }, body: "{}"
        });
        if (!r.ok) throw new Error("HTTP " + r.status);
        var d = await r.json();
        if (d.ok || !d.reason) {  // sent — or a server-side send failure whose own message explains
          if (card) card.remove();
          syncMessages(d); scroll(); return;
        }
        // the saved email was rejected server-side — fall back to asking in-chat
        hasEmail = false; if (card) card.remove();
        afterEmail = "lead"; promptEmail("lead"); return;
      } catch (e) {
        if (errBox) { errBox.textContent = "Couldn't send that just now — please try again."; errBox.style.display = ""; }
      }
      if (btn) { btn.disabled = false; btn.textContent = "Yes, follow me up"; }
    }

    // Quick-pick chips (voltage + form factor) for customers without a model/photo. Picking
    // one of each enables "Show options", which sends the combined spec as a normal message.
    function selectorBlock(sel) {
      var wrap = el("div", "psmrf-selectors");
      var picked = { type: null, voltage: null };
      function row(key, label, opts) {
        var r = el("div", "psmrf-selrow", '<span class="psmrf-sellabel">' + esc(label) + "</span>");
        var chips = el("div", "psmrf-chips");
        (opts || []).forEach(function (o) {
          var c = el("button", "psmrf-chip", esc(o));
          c.addEventListener("click", function () {
            var was = picked[key] === o;
            chips.querySelectorAll(".psmrf-chip").forEach(function (x) { x.classList.remove("on"); });
            picked[key] = was ? null : o;
            if (!was) c.classList.add("on");
            go.disabled = !(picked.type && picked.voltage);
          });
          chips.appendChild(c);
        });
        r.appendChild(chips);
        return r;
      }
      if (sel.type) wrap.appendChild(row("type", "Type", sel.type));
      if (sel.voltage) wrap.appendChild(row("voltage", "Voltage", sel.voltage));
      var go = el("button", "psmrf-btn psmrf-selgo", "Show options →");
      go.disabled = true;
      go.addEventListener("click", function () {
        if (picked.type && picked.voltage) sendText(picked.voltage + " " + picked.type);
      });
      wrap.appendChild(go);
      return wrap;
    }

    // Spec prefix "24V · 100W · " for power products; "" for everything else (lights, switches,
    // enclosures…) which have no voltage/wattage — so their cards don't render a blank "V · W ·".
    function specBits(c) {
      return (c.voltage != null && c.power != null)
        ? (esc(c.voltage) + "V · " + esc(c.power) + "W · ") : "";
    }
    // The price cell.
    //  • Retail store (PSM): the live-resolving price span (resolvePrices swaps in the storefront
    //    price by handle).
    //  • B2B store (NZ) with a price: the server resolved THIS customer's trade price (their company
    //    catalogue price) and put it on the card — show it as-is (no data-handle, so it's not re-fetched).
    //  • B2B, no price: a guest gets a clickable "Sign in for price"; a signed-in customer (or a product
    //    not in their catalogue) is pointed to the product page.
    function priceHtml(c) {
      if (!priceGate) {
        return '<span class="psmrf-price" data-handle="' + esc(c.handle || "") + '">' + money(c.price) + "</span>";
      }
      if (c.price != null) return '<span class="psmrf-price">' + money(c.price) + "</span>";
      return signedIn
        ? '<span class="psmrf-price psmrf-pg">Price on product page</span>'
        : '<a class="psmrf-price psmrf-pg psmrf-pglink" href="#" data-signin="1">Sign in for price</a>';
    }
    function bindSignin(node) {
      var pg = node.querySelector && node.querySelector("[data-signin]");
      // stopPropagation: on an alternative card the whole row also opens the product page — the
      // sign-in link must not trigger that too.
      if (pg) pg.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); gotoSignin(); });
    }
    function card(c, best) {
      var head = c.headroom_w;
      var headTxt = head != null && head > 0
        ? "+" + head + "W over your " + (c.load_w != null ? c.load_w + "W" : "load")
        : (head === 0 ? "matches your load" : "");
      var img = c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy" onerror="this.style.visibility=\'hidden\'">' : "";
      var stock = c.in_stock
        ? '<em>' + (c.inventory != null ? c.inventory + " in stock" : "in stock") + "</em>"
        : '<em class="oos">backorder</em>';
      if (best) {
        var n = el("div", "psmrf-best");
        n.innerHTML =
          '<div class="tag">' + ICONS.check + " " + esc(c.tag || "Best replacement") + "</div>" +
          '<div class="psmrf-prod">' + img +
          '<div class="pi"><b>' + esc(c.title || c.sku) + "</b>" +
          '<div class="ps">' + specBits(c) + esc(c.product_type || "") + "</div>" +
          '<div class="pp">' + priceHtml(c) + " " + stock + "</div></div></div>" +
          (c.reason ? '<div class="psmrf-reason">' + ICONS.check + "<span>" + esc(c.reason) + "</span></div>" : "") +
          '<div class="psmrf-acts"><a class="psmrf-btn red" href="' + esc(productUrl(c)) + '" target="_blank" rel="noopener">View product</a></div>';
        bindSignin(n);
        return n;
      }
      var stk = c.in_stock ? (c.inventory != null ? c.inventory + " in stock" : "in stock") : "backorder";
      // Alternatives lead with WHY you'd pick this over the recommended model (c.diff, from the
      // backend) so the customer can choose from the card; fall back to the headroom badge.
      var sub = c.diff
        ? '<div class="diff">' + esc(c.diff) + "</div>"
        : (headTxt ? '<div class="head">' + ICONS.up + " " + headTxt + "</div>" : "");
      var a = el("div", "psmrf-alt");
      a.innerHTML = img +
        '<div class="ai"><b>' + esc(c.sku || c.title) + "</b>" +
        '<div class="as">' + (specBits(c) || (c.product_type ? esc(c.product_type) + " · " : "")) + esc(stk) + "</div>" +
        sub +
        "</div><div class=\"ap\">" + priceHtml(c) + "</div>";
      a.style.cursor = "pointer";
      a.addEventListener("click", function () { window.open(productUrl(c), "_blank"); });
      bindSignin(a);
      return a;
    }

    // Render the product/article cards attached to an assistant message. Driven by message.cards
    // (not the live payload) so the cards RESTORE when the chat is reopened on another page.
    function renderCards(c) {
      if (!c) return;
      if (c.best) {
        log.appendChild(card(c.best, true));
        if (c.alternatives && c.alternatives.length) {
          var wrap = el("div", "psmrf-alts");
          c.alternatives.forEach(function (a) { wrap.appendChild(card(a, false)); });
          log.appendChild(wrap);
        }
      }
      if (c.articles && c.articles.length) {
        var aw = el("div", "psmrf-articles");
        aw.innerHTML = '<div style="font-size:12px;color:#8a857c;margin:8px 0 2px">Related help</div>' +
          c.articles.map(function (a) {
            return '<a href="' + esc(safeUrl(a.url)) + '" target="_blank" rel="noopener" ' +
              'style="display:block;font-size:13.5px;color:#c13021;text-decoration:none;padding:3px 0">› ' +
              esc(a.title) + "</a>";
          }).join("");
        log.appendChild(aw);
      }
    }

    function render(d) {
      hideTyping();
      lastDetected = d.detected || lastDetected;  // kept for the human-handoff context, not rendered
      syncMessages(d);

      // The SERVER can now initiate a human handoff (auto-routed sales lead): flip to human
      // mode exactly like resume() does, so the rep's replies start appearing.
      if (d.mode === "human" && !humanMode) {
        stopWatching();
        humanMode = true; setHumanUI(); startPolling();
        maybeWaitProgress();  // staged "finding you a specialist" indicator until the first rep reply
      }
      if (d.email_captured) {
        hasEmail = true;
        var act = afterEmail; afterEmail = null;
        if (act === "handoff") humanHandoff();          // gate answered → connect now
        else if (act === "lead") submitSalesLead(null, null, null);  // quote request completes
      }

      if (d.request_photo) log.appendChild(uploadZone("Photo of " + d.request_photo));
      if (d.price_match_form) openPriceMatchForm();  // the model recognised a price-match request
      if (d.sales_lead_capture) renderLeadCard();
      if (d.selectors) log.appendChild(selectorBlock(d.selectors));
      // Product + article cards now render inline with their assistant message (renderMessage →
      // renderCards), driven by message.cards, so they survive a page-navigation resume.
      // The sign-in / escalate prompts are "latest-turn" calls to action — drop any earlier copy so
      // repeated turns can't stack multiple identical buttons down the log.
      Array.prototype.forEach.call(log.querySelectorAll(".psmrf-signin, .psmrf-humanbtn"), function (b) { b.remove(); });
      if (d.needs_login) {
        var sb = el("button", "psmrf-btn psmrf-signin", ICONS.user + " Sign in to continue");
        sb.addEventListener("click", gotoSignin);
        log.appendChild(sb);
      }
      if (d.escalate) {
        var b = el("button", "psmrf-btn psmrf-humanbtn", ICONS.head + " " + humanLabel());
        b.addEventListener("click", function () { if (humanAvailable) humanHandoff(); else startLeaveMessage(); });
        log.appendChild(b);
      }
      resolvePrices();
      scroll();
    }

    // Replace catalog prices with the live storefront price for THIS customer
    // (carries their market + B2B catalog context → matches the PDP exactly).
    function resolvePrices() {
      // B2B store: never fetch a live price. The storefront /products/{handle}.js endpoint returns
      // the DEFAULT catalog (list) price, not the signed-in customer's company price — so resolving
      // would put the WRONG number back on the card. Prices stay gated (see priceHtml).
      if (priceGate) return;
      var nodes = log.querySelectorAll('.psmrf-price[data-handle]:not([data-r])');
      Array.prototype.forEach.call(nodes, function (n) {
        var h = n.getAttribute("data-handle");
        n.setAttribute("data-r", "1");
        if (!h) return;
        fetch("/products/" + encodeURIComponent(h) + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p && typeof p.price === "number") {
              n.textContent = (p.price_varies ? "from " : "") + money(p.price / 100);
            }
          })
          .catch(function () {});
      });
    }

    function err(msg) { hideTyping(); log.appendChild(el("div", "psmrf-err", "⚠ " + esc(msg))); scroll(); }

    // ── human handoff (Chatwoot bridge; customer stays in this widget) ──
    async function humanHandoff() {
      if (humanMode) return;
      armNotifications();
      if (mode === "floating" && launcher) launcher.style.display = "none";
      if (panel) panel.style.display = "flex";
      if (!sid) await ensureSession();
      showTyping();
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/handoff", { method: "POST" });
        if (!r.ok) { hideTyping(); err("Couldn't reach our team just now."); onHuman(detected()); return; }
        var d = await r.json();
        hideTyping();
        if (d.need_contact) {
          syncMessages(d);
          afterEmail = "handoff";  // the captured email completes the connect
          promptEmail("gate");
          return;
        }
        if (d.connected || d.mode === "human") {
          stopWatching();
          humanMode = true;
          setHumanUI();
          syncMessages(d); scroll();
          startPolling();
          maybeWaitProgress();  // staged "finding you a specialist" indicator until the first rep reply
        } else {
          syncMessages(d); scroll();
          onHuman(detected());   // fallback to vendor chat (e.g. Zoho) if Chatwoot is off
        }
      } catch (e) {
        hideTyping(); err("Couldn't reach our team just now."); onHuman(detected());
      }
    }
    // Waiting-for-rep indicator: staged status text + indeterminate progress bar, shown from
    // connect until the FIRST rep reply. Cleared by addAgent (rep spoke) and endHumanMode
    // (fallback / resolve). Purely cosmetic — polling/cut-in logic is unchanged.
    function maybeWaitProgress() {
      if (!humanMode) return;
      if (log.querySelector(".psmrf-stagecard")) return;               // never two
      if (log.querySelector(".psmrf-msg.agent")) return;               // a rep already replied
      var c = el("div", "psmrf-stagecard",
        '<div class="psmrf-stagetop"><span class="psmrf-stagemini">' + ICONS.head + "</span>" +
        '<span class="psmrf-stagetext"><span>Notifying our team…</span>' +
        "<span>Finding you a specialist…</span>" +
        "<span>Almost there — hang tight…</span></span></div>" +
        '<div class="psmrf-stagetrack"><i></i></div>');
      log.appendChild(c); scroll();
    }
    function clearWaitProgress() { var c = log.querySelector(".psmrf-stagecard"); if (c) c.remove(); }
    // "While you wait" email ask — deliberately a BOXED INPUT (not a chat line): while waiting
    // for a rep, the main input reads as "for the conversation", so a plain ask doesn't look like
    // it expects an answer. The other email asks stay conversational.
    function renderWaitEmailCard() {
      if (log.querySelector(".psmrf-waitcard")) return;
      contactAsked = true;  // this IS the email ask — no soft-ask on top
      var card = el("div", "psmrf-contact psmrf-waitcard",
        "<b>\u2709\ufe0f While you wait</b> <span>\u2014 leave your email so we can follow up if we get disconnected.</span>" +
        '<div class="psmrf-contactrow"><input type="email" class="psmrf-pmin" placeholder="you@example.com">' +
        '<button class="psmrf-btn red" type="button">Save</button></div>' +
        '<div class="psmrf-pmerr" style="display:none"></div>' +
        '<button class="psmrf-contactskip" type="button">Skip</button>');
      var inp = card.querySelector("input"), errBox = card.querySelector(".psmrf-pmerr");
      card.querySelector(".psmrf-contactskip").addEventListener("click", function () { card.remove(); });
      card.querySelector(".psmrf-btn").addEventListener("click", async function () {
        var v = inp.value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { errBox.textContent = contactCopy("syntax"); errBox.style.display = ""; return; }
        try {
          var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/email", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: v })
          });
          if (!r.ok) throw new Error("HTTP " + r.status);
          var d = await r.json();
          if (d.ok) { hasEmail = true; card.innerHTML = "<b>\u2713 Thanks</b> <span>\u2014 we'll only use it if we lose you.</span>"; }
          else { errBox.textContent = contactCopy(d.reason); errBox.style.display = ""; }
        } catch (e) { card.remove(); }  // optional capture \u2014 never surface an error for it
      });
      log.appendChild(card); scroll();
    }
    function setHumanUI() {
      stopAmbient();  // human mode has its own 4s poll
      var lc = log.querySelector(".psmrf-leadcard"); if (lc) lc.remove();  // a rep is live — the offline quote card is moot (all human-mode entries pass through here)
      var lo = log.querySelector(".psmrf-leaveoffer"); if (lo) lo.remove();
      Array.prototype.forEach.call(log.querySelectorAll(".psmrf-uploadzone"), function (z) { z.style.display = "none"; });
      var st = panel.querySelector(".psmrf-head .t span"); if (st) st.textContent = "Connected to our team";
      var hb = panel.querySelector(".psmrf-humanlink"); if (hb) hb.style.display = "none";
      var ab = panel.querySelector(".psmrf-attach"); if (ab) ab.style.display = "";  // allow file uploads to the agent
      // Auto-routed guests reached the team WITHOUT the email gate (deliberate — never stall a
      // hot lead). Ask for it non-blockingly while they wait, so a dropped chat is recoverable.
      if (!signedIn && !hasEmail && !log.querySelector(".psmrf-msg.agent")) renderWaitEmailCard();  // only while the rep is still silent
    }
    function startPolling() { if (!pollTimer) pollTimer = setInterval(pollHuman, 4000); }
    async function pollHuman() {
      if (!sid || !humanMode) return;
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid));
        if (r.status === 404) {  // session gone (e.g. server restart) — don't strand the customer in a dead chat
          endHumanMode();
          addSystem("This chat has ended. Start a new message any time — the AI is here to help.");
          return;
        }
        if (!r.ok) return;
        var d = await r.json();
        syncMessages(d); scroll();
        if (d.mode && d.mode !== "human") {
          endHumanMode();  // exits human UI + stops the 4s poll
          if (d.rep_timeout) {
            // Rep no-show: the AI has taken over, but the conversation is still open — keep a
            // slow watch so a late rep reply flips us straight back.
            if (d.offer_leave_message) renderLeaveMessageOffer();
            startWatching();
          }
        }
        if (d.sales_lead_capture) renderLeadCard();  // fallback answer landed → quote card
      } catch (e) { /* keep polling */ }
    }
    function endHumanMode() {
      humanMode = false;
      var wc = log.querySelector(".psmrf-waitcard"); if (wc) wc.remove();  // the wait is over either way
      if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
      var hb = panel.querySelector(".psmrf-humanlink"); if (hb) hb.style.display = "";
      var ab = panel.querySelector(".psmrf-attach"); if (ab) ab.style.display = "none";  // back to text-only AI
      clearWaitProgress();  // fallback or resolve — stop the "finding you a specialist" indicator
      applyPresence();  // restore the presence-aware subtitle + human/leave-message label
      startAmbient();
    }
    // Reduced-cadence poll after a rep no-show: catches a late rep reply (cut-in) and any
    // background fallback answer. Cheap (one GET/10s); runs until cut-in or the session ends.
    function startWatching() { stopAmbient(); if (!watchTimer) watchTimer = setInterval(watchForRep, 10000); }
    function stopWatching() { if (watchTimer) { clearInterval(watchTimer); watchTimer = null; } }
    async function watchForRep() {
      if (!sid) { stopWatching(); return; }
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid));
        if (!r.ok) { if (r.status === 404) stopWatching(); return; }
        var d = await r.json();
        syncMessages(d); scroll();
        if (d.sales_lead_capture) renderLeadCard();
        if (d.mode === "human") {  // the rep cut back in — hand the chat back to them
          endLeaveMessage();  // a half-typed leave-message must not swallow their next reply
          stopWatching();
          humanMode = true; setHumanUI(); startPolling();
        }
      } catch (e) { /* keep watching */ }
    }
    // Ambient cut-in poll: a rep can join a pure-AI conversation at any time (all AI chats are
    // mirrored into Chatwoot). One cheap GET every 30s while the panel is open and the tab is
    // visible; the 4s human poll and the 10s no-show watch take precedence.
    function startAmbient() {
      if (ambientTimer || humanMode || watchTimer) return;
      ambientTimer = setInterval(ambientCheck, 30000);
    }
    function stopAmbient() { if (ambientTimer) { clearInterval(ambientTimer); ambientTimer = null; } }
    async function ambientCheck() {
      if (!sid || humanMode || document.hidden) return;
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid));
        if (!r.ok) { if (r.status === 404) stopAmbient(); return; }
        var d = await r.json();
        if (d.mode === "human") { stopAmbient(); syncMessages(d); scroll(); humanMode = true; setHumanUI(); startPolling(); }
      } catch (e) { /* keep trying */ }
    }
    // After a no-show on a customer-initiated handoff: offer the existing leave-message flow.
    function renderLeaveMessageOffer() {
      if (log.querySelector(".psmrf-leaveoffer")) return;
      var b = el("button", "psmrf-btn psmrf-leaveoffer", ICONS.head + " Leave a message for the team");
      b.addEventListener("click", function () { b.remove(); startLeaveMessage(); });
      log.appendChild(b); scroll();
    }

    // ── presence-aware support: show "Talk to a human" only when an agent is ONLINE; otherwise
    // offer "leave a message" (emailed to the team). Polled from GET /support/status. ──
    function subLabel() { return humanAvailable ? "AI + human support" : "AI support"; }
    function humanLabel() { return humanAvailable ? "Talk to a human" : "Leave a message"; }
    // Keep EVERY "talk to a human / leave a message" affordance in sync with live presence — the
    // header link, the hub chip, and any escalate buttons already on screen (they're rendered once,
    // so without this a status change would leave a stale "Talk to a human" chip like the customer saw).
    function applyPresence() {
      if (!panel || humanMode) return;  // while connected to a human, the header shows that instead
      var st = panel.querySelector(".psmrf-head .t span"); if (st) st.textContent = subLabel();
      var hb = panel.querySelector(".psmrf-humanlink");
      if (hb) hb.innerHTML = ICONS.head + " " + humanLabel();
      var hc = panel.querySelector(".psmrf-hub-human");
      if (hc) hc.innerHTML = '<span class="qi">' + ICONS.head + "</span>" + esc(humanLabel());
      var bs = panel.querySelectorAll(".psmrf-humanbtn");
      for (var i = 0; i < bs.length; i++) bs[i].innerHTML = ICONS.head + " " + humanLabel();
    }
    async function pollSupport(fresh) {
      try {
        var r = await fetch(apiBase + "/support/status" + (fresh ? "?fresh=1" : ""));
        if (r.ok) { var d = await r.json(); humanAvailable = !!d.human_available; }
      } catch (e) { humanAvailable = false; }
      applyPresence();
    }
    async function startLeaveMessage() {
      if (humanMode) return;
      if (mode === "floating" && launcher) launcher.style.display = "none";
      if (panel) panel.style.display = "flex";
      if (!sid) await ensureSession();  // creating the session tells us whether they're signed in
      leaveMsgMode = true;
      // Logged-in customers: we already have their name/email/company (fetched server-side) — don't
      // ask. Anonymous: we'll ask for their email after they type the message.
      leaveMsg = { message: null, email: "", needEmail: !signedIn && !hasEmail, awaiting: "message" };
      addBot(esc("No one's available for live support right now — but you can leave a message and I'll "
        + "email it to our team. Type your message below and we'll get back to you as soon as we can."));
      if (input) { input.placeholder = "Type your message for our team…"; input.focus(); }
      scroll();
    }
    function endLeaveMessage() { leaveMsgMode = false; leaveMsg = null; if (input) input.placeholder = "Ask a question…"; }
    async function submitLeaveMessage(text) {
      if (!leaveMsg) { endLeaveMessage(); return; }
      addUser(esc(text)); scroll();
      if (leaveMsg.awaiting === "message") {
        leaveMsg.message = text;
        if (leaveMsg.needEmail) {  // anonymous → ask for the email so the team can reply
          leaveMsg.awaiting = "email";
          addBot(esc("Got it — one more thing: what's your email address so our team can reply to you?"));
          if (input) input.placeholder = "you@example.com";
          scroll(); return;
        }
      } else if (leaveMsg.awaiting === "email") {
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(text)) {
          addBot(esc("That doesn't look like an email — please enter a valid address (e.g. you@example.com)."));
          scroll(); return;
        }
        leaveMsg.email = text;
      }
      var out = { message: leaveMsg.message, email: leaveMsg.email };
      endLeaveMessage();
      if (!sid) { await ensureSession(); if (!sid) { err("Couldn't send. Please email " + contactEmail + "."); return; } }
      showTyping();
      try {
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/leave-message", {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(out)
        });
        hideTyping();
        if (r.ok) {
          var d = await r.json();
          if (d.invalid_email) {  // server rejected the address — re-ask, don't lose the message
            leaveMsgMode = true;
            leaveMsg = { message: out.message, email: "", needEmail: true, awaiting: "email" };
            addBot(esc(contactCopy(d.reason) + " Our team will use it to reply."));
            if (input) input.placeholder = "you@example.com";
            scroll(); return;
          }
          syncMessages(d); scroll();
        }
        else err("Couldn't send your message. Please email " + contactEmail + ".");
      } catch (e) { hideTyping(); err("Couldn't send your message. Please email " + contactEmail + "."); }
    }

    function resetLog() { log.innerHTML = ""; rendered = 0; }

    // Hub: the support window's landing — pick what to start a conversation about.
    function openHub() {
      resetLog();
      addBot("Hi! 👋 Ask me anything about our products or your order — I'm here to help. "
        + "Type your question below, or start with a popular one:");
      // Suggestion chips, NOT a closed menu — the text box is the primary way in, so a customer
      // with any other need (a return, a product spec, availability) just asks instead of
      // defaulting to a human.
      var chips = el("div", "psmrf-quickchips");
      [["box", "Track my order", startTrackOrder],
       ["cam", "Find a replacement", startReplacement]
      ].forEach(function (o) {
        var c = el("button", "psmrf-quickchip", '<span class="qi">' + ICONS[o[0]] + "</span>" + esc(o[1]));
        c.addEventListener("click", function () { resetLog(); o[2](); });
        chips.appendChild(c);
      });
      if (site === "nz") {  // NZ store only — price match (site is known synchronously; priceGate isn't set until /session)
        var pm = el("button", "psmrf-quickchip", '<span class="qi">' + ICONS.tag + "</span>Price match");
        pm.addEventListener("click", function () { resetLog(); startPriceMatch(); });
        chips.appendChild(pm);
      }
      // Human / leave-message chip — label follows live presence (kept in sync by applyPresence) and
      // the action is decided at click time, so it's always correct even if presence just changed.
      var hc = el("button", "psmrf-quickchip psmrf-hub-human", '<span class="qi">' + ICONS.head + "</span>" + esc(humanLabel()));
      hc.addEventListener("click", function () { resetLog(); if (humanAvailable) humanHandoff(); else startLeaveMessage(); });
      chips.appendChild(hc);
      log.appendChild(chips); scroll();
    }

    // Hub "Track my order": start a session then ask the order question (→ track_order intent,
    // which shows the order, or the Sign-in prompt if the customer isn't logged in).
    async function startTrackOrder() {
      if (!sid) { await ensureSession(); if (!sid) return; }
      sendText("Track my order");
    }

    // Hub "Price match" (NZ only): open the structured request form directly (no model round-trip —
    // the button IS the intent). Free-text asks still route through the model, which returns
    // price_match_form and render() opens the same form.
    async function startPriceMatch() {
      if (!sid) { await ensureSession(); if (!sid) return; }
      addBot("Sure — fill in the quick form below and I'll send your price-match request to our sales team.");
      openPriceMatchForm();
    }

    // The price-match form. Replaces the old conversational field collection: the customer enters
    // everything here and submits in one go. A screenshot posts to /price-match-evidence the moment
    // it's picked (stored on the session); the final submit posts the text fields to /price-match,
    // which emails sales and returns the verbatim confirmation.
    function openPriceMatchForm() {
      if (log.querySelector(".psmrf-pmform")) return;  // never stack two forms
      var wrap = el("div", "psmrf-pmform");
      var hasShot = false;
      function field(key, label, opts) {
        opts = opts || {};
        var row = el("div", "psmrf-pmrow");
        row.appendChild(el("label", "psmrf-pmlabel",
          esc(label) + (opts.optional ? ' <span>(optional)</span>' : "")));
        var inp = el("input", "psmrf-pmin");
        inp.type = opts.type || "text";
        if (opts.placeholder) inp.placeholder = opts.placeholder;
        if (opts.type === "number") { inp.min = "1"; inp.step = "1"; inp.inputMode = "numeric"; }
        row.appendChild(inp);
        wrap.appendChild(row);
        return inp;
      }
      var fSku   = field("sku", "SKU", { placeholder: "e.g. MDR-20-24" });
      var fPrice = field("target_price", "Target price", { placeholder: "e.g. NZ$29 each" });
      var fQty   = field("qty", "Quantity", { type: "number", placeholder: "e.g. 20" });
      var fName  = field("name", "Your name");
      var fEmail = field("email", "Your email", { type: "email", placeholder: "you@company.co.nz" });
      var fLink  = field("evidence_link", "Competitor link", { type: "url", optional: true, placeholder: "https://…" });

      // Screenshot — optional only if a competitor link is given; posts to the evidence endpoint on pick.
      var shotRow = el("div", "psmrf-pmrow");
      shotRow.appendChild(el("label", "psmrf-pmlabel", 'Screenshot <span>(or paste a link above)</span>'));
      var shotBtn = el("button", "psmrf-pmshot", ICONS.cam + "<span>Attach a screenshot</span>");
      shotBtn.type = "button";
      shotRow.appendChild(shotBtn);
      wrap.appendChild(shotRow);

      var errBox = el("div", "psmrf-pmerr"); errBox.style.display = "none"; wrap.appendChild(errBox);
      var submit = el("button", "psmrf-btn red psmrf-pmsubmit", "Submit price-match request");
      submit.type = "button";
      wrap.appendChild(submit);
      function showErr(msg) { errBox.textContent = msg; errBox.style.display = ""; scroll(); }

      shotBtn.addEventListener("click", function () {
        pendingUpload = function (file) {
          if (!/^image\//.test(file.type)) { showErr("Please attach an image (JPG or PNG)."); return; }
          shotBtn.disabled = true; shotBtn.innerHTML = ICONS.cam + "<span>Uploading…</span>";
          var fd = new FormData(); fd.append("file", file, file.name || "screenshot.png");
          fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/price-match-evidence", { method: "POST", body: fd })
            .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
            .then(function () {
              hasShot = true; shotBtn.disabled = false; shotBtn.classList.add("on");
              shotBtn.innerHTML = ICONS.check + "<span>" + esc(file.name || "screenshot attached") + "</span>";
              errBox.style.display = "none";
            })
            .catch(function () {
              shotBtn.disabled = false; shotBtn.innerHTML = ICONS.cam + "<span>Attach a screenshot</span>";
              showErr("Couldn't upload that image. Try again, or paste a competitor link instead.");
            });
        };
        fileInput.click();
      });

      submit.addEventListener("click", function () {
        var body = {
          sku: fSku.value.trim(), target_price: fPrice.value.trim(),
          qty: parseInt(fQty.value, 10), name: fName.value.trim(),
          email: fEmail.value.trim(), evidence_link: fLink.value.trim(),
        };
        if (!body.sku) return showErr("Please enter the SKU.");
        if (!body.target_price) return showErr("Please enter your target price.");
        if (!(body.qty >= 1)) return showErr("Please enter a quantity (1 or more).");
        if (!body.name) return showErr("Please enter your name.");
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(body.email)) return showErr("Please enter a valid email address.");
        if (!hasShot && !body.evidence_link) return showErr("Please attach a screenshot or paste a competitor link.");
        errBox.style.display = "none"; submit.disabled = true; submit.textContent = "Sending…";
        fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/price-match", {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status)); })
          .then(function (d) {
            if (d && d.ok) { hasEmail = true; wrap.remove(); syncMessages(d); scroll(); }
            else {
              submit.disabled = false; submit.textContent = "Submit price-match request";
              showErr("Couldn't send your request just now — please email " + contactEmail + " directly.");
            }
          })
          .catch(function () {
            submit.disabled = false; submit.textContent = "Submit price-match request";
            showErr("Couldn't send your request just now — please email " + contactEmail + " directly.");
          });
      });

      // Pre-fill name + email for a signed-in customer from their VERIFIED Shopify profile (editable).
      if (signedIn) {
        fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/prefill", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d) return;
            if (d.name && !fName.value) fName.value = d.name;
            if (d.email && !fEmail.value) fEmail.value = d.email;
          })
          .catch(function () {});
      }

      log.appendChild(wrap); scroll();
      try { fSku.focus(); } catch (e) {}
    }

    // Reset everything to a fresh AI conversation — the "Start a new chat" button, and the
    // escape hatch when a human has closed the backend conversation (so the customer is never
    // stuck in a dead human chat and can re-engage the assistant).
    function newChat() {
      try { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } } catch (e) {}
      try { if (watchTimer) { clearInterval(watchTimer); watchTimer = null; } } catch (e) {}
      try { if (ambientTimer) { clearInterval(ambientTimer); ambientTimer = null; } } catch (e) {}
      clearSid();
      sid = null; started = false; humanMode = false; photoCount = 0; rendered = 0;
      leaveMsgMode = false; leaveMsg = null; if (input) input.placeholder = "Ask a question…";
      contactAsked = false; hasEmail = signedIn ? hasEmail : false; afterEmail = null;
      var hb = panel.querySelector(".psmrf-humanlink"); if (hb) hb.style.display = "";
      var ab = panel.querySelector(".psmrf-attach"); if (ab) ab.style.display = "none";
      applyPresence();  // presence-aware subtitle + human/leave-message label
      openHub();
      startAmbient();
    }

    // Send the customer to the storefront login, returning to THIS page so the chat re-mounts
    // signed in (the saved session resumes). Used by the order/return "Sign in to continue"
    // prompt and the B2B "Sign in for price" card hint.
    function gotoSignin() {
      try { localStorage.setItem(REOPEN_KEY, "1"); } catch (e) {}
      var ret = encodeURIComponent(location.pathname + location.search + location.hash);
      window.location.href = storefront + "/account/login?return_url=" + ret;
    }

    // Fetch (and cache) a verified-identity token from the App Proxy. Returns null when
    // logged out / not configured / on any error — order & return access just stays off,
    // nothing breaks. Re-fetches when the cached token is within 30s of expiry.
    async function identityToken() {
      if (!identityUrl) return null;
      var now = Math.floor(Date.now() / 1000);
      if (idToken && idExp - 30 > now) return idToken;
      try {
        var r = await fetch(identityUrl, { credentials: "include", headers: { Accept: "application/json" } });
        if (!r.ok) return null;
        var d = await r.json();
        if (d && d.signed_in && d.token) { idToken = d.token; idExp = d.exp || 0; return idToken; }
      } catch (e) { /* anonymous fallback */ }
      return null;
    }
    async function sessionBody() {
      var b = { site: site };
      var tok = await identityToken();
      if (tok) b.identity_token = tok;
      var stored = loadSid();
      if (stored) b.session_id = stored;  // resume the same server session (+ upgrade after login)
      return b;
    }

    // Reconnect to a stored session after a refresh or the Sign-in redirect. Renders the prior
    // conversation when the server still has it; returns false (and clears the stale id) if not.
    async function resume() {
      try {
        var r = await fetch(apiBase + "/session", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(await sessionBody()) });
        if (!r.ok) { clearSid(); return false; }  // 429/5xx — treat as no session to resume
        var d = await r.json();
        signedIn = !!d.signed_in;
        hasEmail = !!d.has_email;
        priceGate = !!d.price_gate; if (d.currency) _cur = d.currency;
        if (d.resumed && d.session_id && (d.messages || []).length) {
          sid = d.session_id; saveSid(sid); started = true;
          resetLog(); syncMessages(d); scroll();
          // If the resumed session is still connected to a human agent, restore that state instead of
          // dropping back to the AI — otherwise clicking "Talk to a human" again opens a SECOND
          // Chatwoot conversation (the "new conversation per message" bug seen across refreshes).
          if (d.mode === "human") { humanMode = true; setHumanUI(); startPolling(); maybeWaitProgress(); }
          else if (d.watch) startWatching();  // fallen back with the conversation still open — watch for a late cut-in
          return true;
        }
      } catch (e) { /* fall through to a fresh start */ }
      clearSid();
      return false;
    }

    // "Find a replacement" — ALWAYS surface the upload box. Previously this early-returned
    // once a session had started (e.g. after the customer typed anything), so tapping the
    // chip wiped the log and showed nothing. Now: start a session if there isn't one, then
    // show the upload zone regardless; if a person is already on the line, leave it to them.
    async function startReplacement() {
      if (humanMode) return;
      if (!sid) {
        started = true;
        try {
          var r = await fetch(apiBase + "/session", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(await sessionBody()) });
          if (!r.ok) { err(r.status === 429 ? "You're going a bit fast — please wait a moment and try again." : "Couldn't start the assistant just now."); return; }
          var d = await r.json(); sid = d.session_id; saveSid(sid);
          signedIn = !!d.signed_in; hasEmail = !!d.has_email; priceGate = !!d.price_gate; if (d.currency) _cur = d.currency; render(d);
        } catch (e) { err("Couldn't start the assistant. " + e.message); return; }
      } else {
        addBot("Sure — upload a photo of your power supply's label and I'll find the right replacement.");
      }
      log.appendChild(uploadZone("Take / upload a photo of the label"));
    }
    // Silent session for a DIRECT "talk to a human" — no AI greeting / upload prompt.
    async function ensureSession() {
      if (sid) return; started = true;
      try {
        var r = await fetch(apiBase + "/session", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(await sessionBody()) });
        if (!r.ok) { err(r.status === 429 ? "You're going a bit fast — please wait a moment and try again." : "Couldn't start the chat just now."); return; }
        var d = await r.json(); sid = d.session_id; saveSid(sid);
        signedIn = !!d.signed_in;
        hasEmail = !!d.has_email;
        priceGate = !!d.price_gate; if (d.currency) _cur = d.currency;
        rendered = (d.messages || []).length;  // record the greeting but don't render it
      } catch (e) { err("Couldn't start the chat. " + e.message); }
    }
    async function upload(file) {
      if (photoCount >= 6) { err("That's plenty of photos — tap “Human” and our team will take it from here."); return; }
      photoCount++;
      addUserThumb(file, true);
      rendered++;  // count the optimistic photo bubble so the backend's "[photo uploaded]" isn't shown twice
      showTyping();
      try {
        var blob = await downscale(file);
        var fd = new FormData(); fd.append("file", blob, "photo.jpg");
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/upload", { method: "POST", body: fd });
        if (!r.ok) throw new Error("HTTP " + r.status);
        render(await r.json());
        maybeSoftAsk();
      } catch (e) { err("Upload failed. " + e.message); }
    }
    // Human-mode file upload → relayed to the agent via Chatwoot. The file is sent as-is
    // (no client downscale: agents may need the original PDF/photo/doc the customer has).
    async function uploadAttachment(file) {
      if (!humanMode || !sid) return;
      if (file.size > 12 * 1024 * 1024) { err("That file is too large (max 12MB)."); return; }
      addUserThumb(file, /^image\//.test(file.type));
      rendered++;  // count the optimistic bubble so the backend's "[sent a file: …]" isn't shown twice
      try {
        var fd = new FormData(); fd.append("file", file, file.name);
        var r = await fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/attach", { method: "POST", body: fd });
        if (!r.ok) throw new Error("HTTP " + r.status);
        var d = await r.json();
        syncMessages(d); scroll();
      } catch (e) { err("Couldn't send the file. " + e.message); }
    }
    function postMessage(t) {
      return fetch(apiBase + "/session/" + encodeURIComponent(sid) + "/message", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ text: t })
      });
    }
    async function sendText(t) {
      armNotifications();
      if (leaveMsgMode) { return submitLeaveMessage(t); }  // this turn is a message for the team, not the AI
      if (!sid) { await ensureSession(); if (!sid) return; }  // typed from the hub menu — start a session first
      addUser(esc(t)); rendered++; showTyping();  // count the optimistic bubble so syncMessages won't duplicate it
      try {
        var r = await postMessage(t);
        if (r.status === 404) {                  // session lost (e.g. server restarted) — start a fresh one and retry
          sid = null; await ensureSession();
          if (!sid) { hideTyping(); err("Couldn't reconnect. Please try again."); return; }
          rendered++;                            // keep the already-shown user bubble from re-rendering
          r = await postMessage(t);
        }
        var dd = await r.json();
        render(dd);
        maybeSoftAsk();
        if (afterEmail && !dd.email_captured) afterEmail = null;  // one-shot: a non-email reply drops the pending connect/quote
      } catch (e) { err("Message failed. " + e.message); }
    }

    build();

    var api = {
      root: root,
      open: function (view) {
        if (mode === "floating" && launcher) launcher.style.display = "none";
        if (panel) panel.style.display = "flex";
        pollSupport(true);  // fresh availability check whenever the chat is opened
        startAmbient();
        if (started || humanMode || opening) return;
        opening = true;  // synchronous latch so a double-open can't fire two concurrent resume()s
        var go = function () {
          if (view === "replacement") startReplacement();
          else if (view === "human") humanHandoff();
          else openHub();
        };
        // Reconnect to a saved conversation first (survives refresh + the Sign-in redirect).
        if (loadSid()) resume().then(function (ok) { opening = false; if (!ok) go(); });
        else { opening = false; go(); }
      },
      destroy: function () {  // tear down timers + global listeners (call before re-mounting)
        try { if (supportTimer) { clearInterval(supportTimer); supportTimer = null; } } catch (e) {}
        try { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } } catch (e) {}
        try { if (watchTimer) { clearInterval(watchTimer); watchTimer = null; } } catch (e) {}
        try { if (ambientTimer) { clearInterval(ambientTimer); ambientTimer = null; } } catch (e) {}
        try { if (onVis) document.removeEventListener("visibilitychange", onVis); } catch (e) {}
        try { if (onFocus) window.removeEventListener("focus", onFocus); } catch (e) {}
        try { if (root && root.parentNode) root.parentNode.removeChild(root); } catch (e) {}
      },
      el: root
    };
    _instance = api;

    if (mode === "floating") {
      // single support launcher -> opens the hub window
      launcher = el("div", "psmrf-launcher");
      var fab = el("button", "psmrf-fab", ICONS.support + " " + esc(brandName));
      launcher.appendChild(fab);
      panel.style.display = "none";
      fab.addEventListener("click", function () { api.open("hub"); });
      if (panel.querySelector(".x")) {
        panel.querySelector(".x").addEventListener("click", function () { launcher.style.display = "flex"; });
      }
      document.body.appendChild(launcher);
      document.body.appendChild(panel);
    } else {
      var target = typeof opts.el === "string" ? document.querySelector(opts.el) : opts.el;
      target.appendChild(root);
      // a dedicated inline mount opens straight into the requested flow (default: replacement)
      if (opts.view === "hub") openHub();
      else startReplacement();
    }
    // Returning from the Sign-in redirect: auto-open + resume so the customer lands back in
    // the same conversation, now signed in (the resume call upgrades the session's customer).
    try { if (localStorage.getItem(REOPEN_KEY)) { localStorage.removeItem(REOPEN_KEY); setTimeout(function () { api.open("hub"); }, 250); } } catch (e) {}
    return api;
  }

  window.PSMReplacementFinder = {
    mount: mount,
    // Open the most-recently-mounted widget. view: 'hub' | 'replacement' | 'human'.
    open: function (view) { if (_instance) { _instance.open(view); } return _instance; }
  };
})();
